// @ts-ignore
import { CKEditor } from '@ckeditor/ckeditor5-react';
// @ts-ignore
import CustomBuild from 'ckeditor5-custom-build';
import { useState } from 'react';
import { IFormItemProps } from '../../types/components/form';
import { IHtmlEditorLayout } from '../../types/layout/html-editor';
import expandIcon from '../../assets/icons/expand-solid.svg';
import { useHtmlEditor } from '../../hooks/html-editor/useHtmlEditor';
import Loader from '../loader';

type THtmlEditorProps = IHtmlEditorLayout & IFormItemProps;

function HtmlEditor(props: THtmlEditorProps) {
    const {
        additionalClassName, editable, maxHeight, value, onChange, placeholder,
    } = props;

    const [focused, setFocused] = useState(false);
    const [fullscreen, setFullscreen] = useState(false);
    const { loading } = useHtmlEditor(props);

    const onChangeHandler = (_: any, editor: any) => {
        if (focused) {
            onChange(editor.getData());
        }
    };

    const onFocus = () => setFocused(true);

    const onFullscreenClick = (e: any) => {
        e.preventDefault();
        setFullscreen((prev) => !prev);
    };

    const onReady = (editor: any) => {
        if (editor?.ui?.view?.toolbar?.element?.firstChild) {
            const { firstChild } = editor.ui.view.toolbar.element;
            const btn = document.createElement('button');
            btn.className = 'ck ck-button ck-off';
            btn.innerHTML = `<img src="${expandIcon}" style="height: 16px; width: 16px;" />`;
            btn.onclick = onFullscreenClick;
            firstChild.append(btn);
        }
        if (typeof editor?.editing?.view?.change === 'function') {
            editor.editing.view.change((writer: any) => {
                writer.setStyle(
                    'height',
                    `${maxHeight}px`,
                    editor.editing.view.document.getRoot(),
                );
            });
        }
    };

    const classList = [];

    if (typeof additionalClassName === 'string') {
        classList.push(additionalClassName);
    }

    if (fullscreen) {
        classList.push('html-editor-fullscreen');
    }

    return (
        <div className={classList.join(' ')}>
            <Loader loading={loading} />
            <CKEditor
                disabled={editable === false}
                editor={CustomBuild}
                data={focused ? (value || '') : (value || placeholder)}
                onChange={onChangeHandler}
                onFocus={onFocus}
                onReady={onReady}
            />
        </div>
    );
}

export default HtmlEditor;
